import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IToken } from '@shared/interfaces/token.interface';
import { OAuthService } from '@shared/services/oauth.service';
import { StorageService } from '@shared/services/storage.service';
@Component({
  selector: 'hadsup-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  title = 'HadsUpLandlord';
  constructor(
    private oauth: OAuthService,
    private router: Router,
    private route: ActivatedRoute,
    private storageService: StorageService
  ) {
  }

  async ngOnInit() {
    await this.route.queryParams.subscribe((params) => {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('scope') !== null) {
        this.router.navigate(['/reset-password'], {
          queryParams: {
            token: urlParams.get('token'),
            scope: urlParams.get('scope'),
            email: urlParams.get('email'),
            country: urlParams.get('country'),
            type: urlParams.get('type'),
          },
        });
      }
      if (urlParams.get('token') !== null && urlParams.get('scope') === null && urlParams.get('type') === null) {
        const access = {
          access_token: urlParams.get('token'),
          expires_in: Date.now() + 3600 * 1000,
          refresh_token: '',
        };
        const client = {
          access_token: urlParams.get('token'),
          expires_in: Date.now() + 3600 * 1000,
          token_type: 'Bearer',
        };
        localStorage.setItem('ClientAccessToken', JSON.stringify(client));
        localStorage.setItem('AccessToken', JSON.stringify(access));
      }
    });
    this.oauth.Token().subscribe((result: IToken) => {
      result.expires_in = Date.now() + result.expires_in * 1000;
      this.storageService.setClientAccessToken(result);
    });
    const token = this.storageService.getAccessToken();
    if (token && token.expires_in < Date.now()) {
      const data: any = { refresh_token: token.refresh_token };
      this.oauth
        .RefreshToken(data)
        .subscribe((response) => {
          const tokenObject = {} as IToken;
          tokenObject.access_token = response.access_token;
          tokenObject.expires_in = Date.now() + response.expires_in * 1000;
          tokenObject.refresh_token = response.refresh_token;
          this.storageService.removeAccessToken();
          this.storageService.setAccessToken(tokenObject);
          this.storageService.setUserInfo(response.data);
        }, (error) => {
          if (error.error?.errors?.[0]?.errors) {
            this.storageService.removeAll();
            this.router.navigate(['/login']);
          }
        })
        .add(() => {
          window.location.reload();
        });
    }
  }

}
